module.exports = __webpack_public_path__ + "static/img/pro2.b6f33c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/dashboard/pro2.png
// module id = 570
// module chunks = 2